const latestArticle = {
  "status": "true",
  "message": "取得最新文章",
  "total": "3",
  "ArticleList": [
    {
      "title": "歐盟通過淨零工業法案",
      "author": "林志勳",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=5&domain=28&rpt_idno=893952348",
      "image": `${require('assets/images/home/news-1.jpg')}`
    },
    {
      "title": "IEK360系列 | 師法日本，建立台灣消費行為碳排資料庫",
      "author": "姚雨欣",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=5&domain=28&rpt_idno=375163115",
      "image": `${require('assets/images/home/news-2.jpg')}`
    },
    {
      "title": "2024日本新環境展最新觀察-廢棄物循環走向全流程無人化",
      "author": "陳培琳",
      "url": "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=5&domain=28&rpt_idno=534647184",
      "image": `${require('assets/images/home/news-3.jpg')}`
    },
  ]
}

export default latestArticle;